var render = function render(){var _vm=this,_c=_vm._self._c;return _c('colored-number',{attrs:{"value":_vm.value,"threshold":"100"}})
}
var staticRenderFns = []

export { render, staticRenderFns }